// extracted by mini-css-extract-plugin
export var brand = "_8l-9";
export var compact = "_8l-6";
export var extraSmall = "_8l-7";
export var icon = "_8l-0";
export var large = "_8l-4";
export var light = "_8l-1";
export var medium = "_8l-5";
export var outline = "_8l-b";
export var primaryDark = "_8l-a";
export var primaryLight = "_8l-8";
export var primaryModern = "_8l-c";
export var success = "_8l-2";
export var successSolid = "_8l-3";